var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.701 4.87316L11.4823 0.654512C11.3838 0.556004 11.2494 0.5 11.1094 0.5H3.72656C2.85423 0.5 2.14453 1.2097 2.14453 2.08203V16.918C2.14453 17.7903 2.85423 18.5 3.72656 18.5H14.2734C15.1458 18.5 15.8555 17.7903 15.8555 16.918V5.24609C15.8555 5.1023 15.7951 4.96727 15.701 4.87316ZM11.6367 2.30046L14.055 4.71875H12.1641C11.8733 4.71875 11.6367 4.48218 11.6367 4.19141V2.30046ZM14.2734 17.4453H3.72656C3.43579 17.4453 3.19922 17.2087 3.19922 16.918V2.08203C3.19922 1.79125 3.43579 1.55469 3.72656 1.55469H10.582V4.19141C10.582 5.06374 11.2917 5.77344 12.1641 5.77344H14.8008V16.918C14.8008 17.2087 14.5642 17.4453 14.2734 17.4453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 7.95312H5.83594C5.5447 7.95312 5.30859 8.18923 5.30859 8.48047C5.30859 8.7717 5.5447 9.00781 5.83594 9.00781H12.1641C12.4553 9.00781 12.6914 8.7717 12.6914 8.48047C12.6914 8.18923 12.4553 7.95312 12.1641 7.95312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 10.0625H5.83594C5.5447 10.0625 5.30859 10.2986 5.30859 10.5898C5.30859 10.8811 5.5447 11.1172 5.83594 11.1172H12.1641C12.4553 11.1172 12.6914 10.8811 12.6914 10.5898C12.6914 10.2986 12.4553 10.0625 12.1641 10.0625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 12.1719H5.83594C5.5447 12.1719 5.30859 12.408 5.30859 12.6992C5.30859 12.9905 5.5447 13.2266 5.83594 13.2266H12.1641C12.4553 13.2266 12.6914 12.9905 12.6914 12.6992C12.6914 12.408 12.4553 12.1719 12.1641 12.1719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0547 14.2812H5.83594C5.5447 14.2812 5.30859 14.5174 5.30859 14.8086C5.30859 15.0998 5.5447 15.3359 5.83594 15.3359H10.0547C10.3459 15.3359 10.582 15.0998 10.582 14.8086C10.582 14.5174 10.3459 14.2812 10.0547 14.2812Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ced05919bf15a2cc074588bda592380c.svg";
export { ForwardRef as ReactComponent };